import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
// Angular Imports
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { NgcPipesModule } from '../../pipes/module';
import { AirportLookupService } from '../../services/airport-lookup-service/airport-lookup.service';
// This Module's Components
import { FullAirportListComponent } from './full-airport-list.component';

@NgModule({ declarations: [FullAirportListComponent],
    exports: [FullAirportListComponent], imports: [CommonModule,
        ModalModule.forRoot(),
        TabsModule.forRoot(),
        NgcPipesModule], providers: [AirportLookupService, provideHttpClient(withInterceptorsFromDi())] })
export class FullAirportListModule {}
